const MartiniqueSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111849)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.8283 17.3918C39.2766 13.1741 37.3821 9.09867 34.1418 5.85844C30.9016 2.6182 26.8261 0.723594 22.6084 0.171875L22.6085 17.3918H39.8283Z"
        fill="#0052B4"
      />
      <path
        d="M17.3913 0.171875C13.1737 0.723594 9.09811 2.61813 5.85787 5.85836C2.61772 9.09867 0.723105 13.1742 0.171387 17.392L17.3914 17.3919L17.3913 0.171875Z"
        fill="#0052B4"
      />
      <path
        d="M0.171387 22.6084C0.723105 26.8261 2.61772 30.9017 5.85787 34.1418C9.09811 37.382 13.1736 39.2765 17.3914 39.8285L17.3913 22.6086L0.171387 22.6084Z"
        fill="#0052B4"
      />
      <path
        d="M22.6094 39.8282C26.827 39.2765 30.9025 37.382 34.1427 34.1418C37.383 30.9015 39.2775 26.8261 39.8292 22.6084H22.6094V39.8282Z"
        fill="#0052B4"
      />
      <path
        d="M26.8276 12.6909C26.8276 12.4249 27.0438 12.2087 27.3098 12.2087H28.3429C29.976 12.2087 31.3047 10.8802 31.3047 9.24711C31.3047 7.61406 29.9761 6.28539 28.3429 6.28539H27.3618C27.0416 6.04484 26.612 5.89648 26.1381 5.89648C25.1495 5.89648 24.3482 6.5375 24.3482 7.32828C24.3482 8.11141 25.1342 8.74672 26.1095 8.75906L26.1091 8.76477H28.3429C28.6089 8.76477 28.8251 8.98102 28.8251 9.24695C28.8251 9.51289 28.6089 9.72906 28.3429 9.72906H27.3098C25.6767 9.72906 24.3481 11.0577 24.3481 12.6907C24.3481 14.3238 25.6766 15.6524 27.3098 15.6524H31.3046V13.1729H27.3098C27.0438 13.173 26.8276 12.9568 26.8276 12.6909Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.1752 12.6909C11.1752 12.4249 11.3913 12.2087 11.6574 12.2087H12.6905C14.3236 12.2087 15.6523 10.8802 15.6523 9.24711C15.6523 7.61406 14.3237 6.28539 12.6905 6.28539H11.7094C11.3892 6.04484 10.9596 5.89648 10.4856 5.89648C9.49713 5.89648 8.6958 6.5375 8.6958 7.32828C8.6958 8.11141 9.48182 8.74672 10.4571 8.75906L10.4567 8.76477H12.6906C12.9566 8.76477 13.1728 8.98102 13.1728 9.24695C13.1728 9.51289 12.9566 9.72906 12.6906 9.72906H11.6574C10.0243 9.72906 8.6958 11.0577 8.6958 12.6907C8.6958 14.3238 10.0242 15.6524 11.6574 15.6524H15.6522V13.1729H11.6574C11.3913 13.173 11.1752 12.9568 11.1752 12.6909Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.8277 31.143C26.8277 30.8771 27.0438 30.6609 27.3099 30.6609H28.343C29.9761 30.6609 31.3048 29.3323 31.3048 27.6993C31.3048 26.0662 29.9762 24.7375 28.343 24.7375H27.3619C27.0417 24.497 26.612 24.3486 26.1381 24.3486C25.1495 24.3486 24.3482 24.9897 24.3482 25.7804C24.3482 26.5636 25.1342 27.1989 26.1095 27.2112L26.1091 27.2169H28.3429C28.6089 27.2169 28.8251 27.4332 28.8251 27.6991C28.8251 27.965 28.6089 28.1812 28.3429 28.1812H27.3098C25.6767 28.1812 24.3481 29.5098 24.3481 31.1429C24.3481 32.7759 25.6766 34.1046 27.3098 34.1046H31.3047V31.6251H27.3099C27.0438 31.6252 26.8277 31.4089 26.8277 31.143Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.1753 31.143C11.1753 30.8771 11.3914 30.6609 11.6574 30.6609H12.6906C14.3237 30.6609 15.6524 29.3323 15.6524 27.6993C15.6524 26.0662 14.3238 24.7375 12.6906 24.7375H11.7095C11.3892 24.497 10.9596 24.3486 10.4857 24.3486C9.49713 24.3486 8.6958 24.9897 8.6958 25.7804C8.6958 26.5636 9.48182 27.1989 10.4571 27.2112L10.4567 27.2169H12.6906C12.9566 27.2169 13.1728 27.4332 13.1728 27.6991C13.1728 27.965 12.9566 28.1812 12.6906 28.1812H11.6574C10.0243 28.1812 8.6958 29.5098 8.6958 31.1429C8.6958 32.7759 10.0242 34.1046 11.6574 34.1046H15.6523V31.6251H11.6574C11.3914 31.6252 11.1753 31.4089 11.1753 31.143Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111849">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MartiniqueSvg;
